import React from "react";
import INRTransactionsPage from "../INRTransactionsPage";

const INRWithdraw = () => <INRTransactionsPage type="WITHDRAW" />;

export default INRWithdraw;
